// Type for allowed OpenAI Models
export type GPTModels =
    | 'gpt-4o'
    | 'gpt-4o-mini'
    | 'gpt-4-turbo'
    | 'gpt-4'
    | 'gpt-3.5-turbo';

// Define a default model
export const DEFAULT_MODEL: GPTModels = 'gpt-4o-mini';
